import { useState } from "react";
import type { ChecklistItem } from "@/mocks/protocolResponses";

interface Props {
  items: ChecklistItem[];
}

export default function ProtocolChecklist({ items }: Props) {
  const [checked, setChecked] = useState<Record<number, boolean>>({});

  if (items.length === 0) return null;

  const toggle = (idx: number) => {
    setChecked((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  const completedCount = Object.values(checked).filter(Boolean).length;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-check-double-line text-accent-600 text-sm" />
          </div>
          <h3 className="text-base font-semibold text-foreground-900">Checklist de Aplicación del Protocolo</h3>
        </div>
        <span className="text-xs text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full font-medium">
          {completedCount}/{items.length}
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full h-1.5 bg-background-200 rounded-full mb-4 overflow-hidden">
        <div
          className="h-full bg-accent-500 rounded-full transition-all duration-300"
          style={{ width: `${items.length > 0 ? (completedCount / items.length) * 100 : 0}%` }}
        />
      </div>

      <div className="space-y-1.5">
        {items.map((item, idx) => (
          <button
            key={idx}
            onClick={() => toggle(idx)}
            className="w-full flex items-start gap-3 px-4 py-3 rounded-xl text-left transition-all cursor-pointer hover:bg-background-50 border border-transparent hover:border-background-200"
          >
            <div
              className={`w-5 h-5 rounded-md border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-all ${
                checked[idx]
                  ? "bg-accent-500 border-accent-500"
                  : "border-background-300 bg-white"
              }`}
            >
              {checked[idx] && <i className="ri-check-line text-white text-xs" />}
            </div>
            <div className="flex-1 min-w-0">
              <p
                className={`text-sm leading-relaxed transition-all ${
                  checked[idx] ? "text-foreground-400 line-through" : "text-foreground-700"
                }`}
              >
                {item.accion}
              </p>
              <p className="text-xs text-foreground-400 mt-0.5">{item.fuente}</p>
            </div>
            {item.obligatoria && (
              <span className="flex-shrink-0 text-xs font-medium text-red-600 bg-red-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                Obligatorio
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}